<template>
  <div>
    <!-- <div class="text-right mb-1">
      <b-button
        variant="primary"
        pill
        @click="createUser"
        v-if="hasPermission('create_user')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Create</span>
      </b-button>
    </div> -->
    <b-card>
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="User Type"
              label-for="user_type"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="user_type"
                placeholder="Select User Type"
                :options="user_types"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Status"
              label-for="status"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="status"
                placeholder="Select Status"
                :options="statuses"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
            
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="flat_users"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_user')"
        :per-page="0"
      >
        <template #cell(user_data)="row">
          {{ row.item.user_data ? row.item.user_data.name : "" }} - {{ row.item.user_data ? row.item.user_data.mobile_number : "" }}
        </template>        

        <template #cell(floor_data)="row">
          {{ row.item.floor_data ? row.item.floor_data.building : "" }} - {{ row.item.floor_data ? row.item.floor_data.name : "" }}
        </template>        
        
        <template #cell(flat_data)="row">
          {{ row.item.flat_data ? row.item.flat_data.name : "" }}
        </template>        

        <template #cell(is_approved)="row">
          <b-badge :variant="badgeVariant(row.item.is_approved)">
            {{ row.item.is_approved === null ? 'Pending' : (row.item.is_approved ? 'Approved':'Rejected') }}
          </b-badge>
        </template>

        <template #cell(manage)="row">
          <b-dropdown pill size="sm"  text="Change Status" variant="info" class="" v-if="hasPermission('update_user')">
            <b-dropdown-item :hidden="row.item.is_approved === true ? true:false" @click="changeStatus(row.item, true)">Approve</b-dropdown-item>
            <b-dropdown-item :hidden="row.item.is_approved === false ? true:false" @click="changeStatus(row.item, false)">Reject</b-dropdown-item>
            <b-dropdown-item :hidden="row.item.is_approved === null ? true:false" @click="changeStatus(row.item, null)">Pending</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    VueSelectPaginated,
  },
  data() {
    return {
      fields: [
        { key: "user_data", label: "User" },
        { key: "floor_data", label: "Floor" },
        { key: "flat_data", label: "Flat" },
        { key: "user_type", label: "User Type" },
        { key: "is_approved", label: "Status" },
        { key: "arrival_time", label: "Arrival" },
        { key: "departure_time", label: "Departure" },
        { key: "manage", label: "Action" },
      ],
     
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      flat_users: [],
      flat_user: null,
      searchTypes: [
        { value: 1, name: "User Type" },
        { value: 2, name: "Status" },
      ],
      searchType: null,
      user_type: "",
      user_types: [
        { id: 'Resident', name: 'Resident' },
        { id: 'Temporary Visitor', name: 'Temporary Visitor' },
        { id: 'Permanent Visitor', name: 'Permanent Visitor' },
      ],
      status: "",
      statuses: [
        { id: true, name: 'Approved' },
        { id: false, name: 'Rejected' },
      ]
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
  },
  methods: {
    ...mapActions({
      getFlatUsers: "appData/getFlatUsers",
      updateFlatUser: "appData/updateFlatUser",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.status = "";
            break;
          case 2:
            this.user_type = "";
            break;
        }
      } else {
        this.user_type = "";
        this.status = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getFlatUsers({
          pageNumber: this.currentPage,
          user_type: this.user_type.id,
          is_approved: this.status.id,
        });

        this.flat_users = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    
    async changeStatus(data, status){      
      try {
        const formData = new FormData();
        formData.append("is_approved", status);        
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateFlatUser({
          payload: formData,
          pk: data.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Status Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();          
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    badgeVariant(status) {
      switch (status) {
        case true:
          return 'success';
        case false:
          return 'danger';
        case null:
          return 'warning';
        
        default:
          return 'light';
      }
    },
    async removeUser(user) {
      this.user = user;
      try {
        const res = await this.deleteUser({
          pk: this.user.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "User deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({ hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser" },
    ),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>

